<template>
  <div class="option-wrapper flex flex-row" :class="{ selected }" @click="$emit('checked', option)">
    <div class="radio"></div>
    <div class="option-name sm:text-2xl">{{ option.name }}</div>
  </div>
</template>

<script>
export default {
  name: 'COption',
  props: {
    option: Object,
    selected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.option-wrapper {
  &.selected {
    .radio {
      background-image: url('../../assets/common/option-selected.svg');
      opacity: 0.8;
    }
    .option-name {
      color: black;
    }
  }
}
.option-name {
  color: #8c8c8c;
}
.radio {
  @apply mr-4;
  width: 24px;
  height: 24px;
  background: url('../../assets/common/option-deselected.svg') no-repeat center;
  background-size: contain;
}
</style>
